import { t } from '../../app/i18n';

export default {
  SIGN_CONTRACT: 'SIGN_CONTRACT',
  ENTER_SMS_CODE_CONTRACT: 'ENTER_SMS_CODE_CONTRACT',
};

export const translation = {
  SIGN_CONTRACT: t('Podpíšte Záväzný pokyn investovať'),
  ENTER_SMS_CODE_CONTRACT: t('Zadajte SMS kód pre potvrdenie'),
};



// WEBPACK FOOTER //
// ./src/common/enums/allocationActions.js